/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {RoleAddEdit } from './RoleAddEdit'
import { propTypes } from 'react-bootstrap/esm/Image';
import axios from 'axios'
import { RoleAddEditPermissions } from './RoleAddEditPermissions';
import { Auth } from 'aws-amplify';

const API_URL_API = process.env.REACT_APP_API_URL_BACKEND
export const GET_ALL_PERMISSIONS_URL = `${API_URL_API}/permission`

export const GET_ALL_ROLES_URL = `${API_URL_API}/role`;

type Props = {
  className : string,
  roles : any,
  getAllRoles : any
}

const RoleTable: React.FC<Props> = ({className, roles, getAllRoles}) => {

    const [showModal, setShowModal] = useState(false);
    const [showPermission, setShowPermission] = useState(false);
    const [roleDetails, setRoleDetails] = useState(null);
    const [allPermissions, setAllPermissions] = useState(null);
    const [data, setData] = useState(null);
    const [edit, setEdit] = useState(false);

    
    const toggleShow = (roleId:any)  => {
        
        setEdit(false);
        if(roleId !== 0){
          setEdit(true);
          roles.map((role:any)=> {
            if(roleId === role.id){
              setData(role);
            }
          });
        
        }

        //console.log('toggleShow ' + permissionId)
        setShowModal(pre => !pre);

        if(showModal){
          console.log('toggleShow ' + roleId);
          getAllRoles();
        }
    }

    // Add/Remove permissions
    const togglePermissionEdit  = async (roleId:any) => {
      
      if(roleId !== null)
      {
        try
        {

          const auth = await Auth.currentSession();

          const token = auth.getAccessToken().getJwtToken();

          const {data: result} = await axios.get(GET_ALL_ROLES_URL + '/' + roleId, {
            headers : {
              Authorization: `Bearer ${token}`
            }
          });//returns single role and permissions
          setRoleDetails(result.data);  

          const {data: response} = await axios.get(GET_ALL_PERMISSIONS_URL, {
            headers : {
              Authorization: `Bearer ${token}`
            }
          });//returns All permissions
          setAllPermissions(response.data);
        
          console.log(roleDetails);
          console.log(allPermissions);
        }
        catch(error)
        {
          console.log(error);
        }
      }

      //console.log('toggleShow ' + permissionId)
      setShowPermission(pre => !pre);      
    }

    const deleteRole = async (roleId:any) => {
      //delete role
      alert("hello");
      try
      {
        await fetch(process.env.REACT_APP_API_URL_BACKEND + '/role/', 
        {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({'role_id': roleId})
        });
        
        getAllRoles();
      }
      catch(error)
      {
        console.log(error);
      }

    }

  return (
    <>
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Roles</span>
        </h3>
        <div className='card-toolbar'>
          <button onClick={() => toggleShow(0)} className='btn btn-sm btn-light-primary'>
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
            Add Roles
          </button>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                <th className='ps-4 min-w-325px rounded-start'>Name</th>
                <th className='min-w-200px text-end rounded-end'></th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
                {roles.map((role:any) => (
                    <tr key={`role-${role.id}`}>
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{role.name}</span></td>
                        <td>
                          <button onClick={() => togglePermissionEdit(role.id)} className='btn btn-sm btn-secondary btn-active-color-primary text-dark'>
                            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-3' />
                            Add/Remove Permissions
                          </button>
                        </td>
                        <td className='text-end'>
                            <a href='#' onClick={() => toggleShow(role.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                            <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                            </a>
                            <a href='#' onClick={() => deleteRole(role.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                            <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                            </a>
                        </td>
                    </tr>
                )
                )}


            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
    {
        showModal ? <RoleAddEdit toggleShow={toggleShow} isUpdate={edit} itemToEdit={data} /> : null
    }

    {
      showPermission ? <RoleAddEditPermissions permissionList={allPermissions} roleDetails={roleDetails} togglePermissionEdit={togglePermissionEdit} /> : null
    }
    </>
  )
}

export {RoleTable}
